import React, { useContext } from 'react';
import API from 'helpers/API';
import {
  getFormErrorsFromApiError,
  mapErrorObjectPropertiesMessagesToInputNamesErrors,
} from 'helpers/apiError';
import CardShell from '../../../components/CardShell';
import CustomEventTypeForm from './CustomEventTypeForm';
import CustomEventTypesContext from './CustomEventTypesContext';

const AddCustomEventType = () => {
  const { customEventTypes, loadCustomEventTypes } = useContext(CustomEventTypesContext);

  const save = async (customEventType) => {
    try {
      await API.createCustomEventType(customEventType);
    } catch (e) {
      if (e.status === 400) {
        const errorsMap = {
          name: { inputName: 'name', label: 'Name' },
        };
        const errors = getFormErrorsFromApiError(e.json);
        throw mapErrorObjectPropertiesMessagesToInputNamesErrors(errors, errorsMap);
      }
      throw e;
    }
    loadCustomEventTypes();
  };

  return (
    <div>
      <h1 className="h2">Add Custom Event Type</h1>
      <div
        className="container__cards"
        style={{ background: '#f7f7f7', maxHeight: '190px' }}
      >
        <CardShell noOverflow>
          <CustomEventTypeForm save={save} customEventTypes={customEventTypes} />
        </CardShell>
      </div>
    </div>
  );
};

export default AddCustomEventType;
